"use strict";
angular.module('emun.auth').component("profile", {
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'profile.html'
    }
});